import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { Injectable } from '@angular/core';
import { RebateRelease } from '@core/models/rebate-release-model';

@Injectable()
export class NewRebateReleaseEntityService extends EntityCollectionServiceBase<RebateRelease>  {

  constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory) {
    super('NewRebateRelease', serviceElementsFactory);
  }
}
